import React, { useEffect, useState, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import HttpService from "../../services/httpService";
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Box, TablePagination, Dialog, DialogTitle,
  DialogContent, DialogActions, Typography
} from '@material-ui/core';
import { Button } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { CSVLink } from "react-csv";
import { RiFileExcel2Fill } from "react-icons/ri";
import { IoMdEye } from "react-icons/io";
import moment from 'moment';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
  },
  headerCell: {
    backgroundColor: '#F47E46',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '16px',
    padding: '16px',
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
  tableRowEven: { backgroundColor: '#ffffff' },
  tableRowOdd: { backgroundColor: '#f0f4f8' },
  cell: {
    fontSize: '14px',
    fontWeight: 'bold',
    padding: '16px',
    textAlign: 'center',
    borderRight: '1px solid #e0e0e0',
  },
  notesCell: {
    fontSize: '14px',
    fontWeight: 'bold',
    textAlign: 'center',
  },
}));

const DrawingClickTable = (props) => {
  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);
  const [csvData, setCsvData] = useState([]);
  const csvRef = useRef();
  const [page, setPage] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);  
  const [open, setOpen] = useState(false);
  const [selectedRemarks, setSelectedRemarks] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const loadingRef = useRef(0);
  const startLoading = () => { loadingRef.current += 1; props.setLoading(true); };
  const stopLoading = () => {
    loadingRef.current -= 1;
    if (loadingRef.current <= 0) {
      loadingRef.current = 0;
      props.setLoading(false);
    }
  };

  useEffect(() => {
    getAllDesignKickOffLeads();
  }, [page, rowsPerPage]);

  const paginatedData = tableData; 

  const stageMap = {
    'Total Drawings': null,
    'Pending ODM Approvals': ['ADM In Progress'],
    'QC Assignment Pending': ['QC Assignment Pending'],
    'Rejected Drawings': ['ADM Rejected'],
    // 'Drawings in QC 1': ['QC1 In Progress', 'QC1 Completed'],
    'QC2 Correction Needed': ['QC2 Correction Needed'],
    // 'Drawings in QC 2': ['QC2 In Progress', 'QC2 Completed'],
    'QC1 In Progress' : ['QC1 In Progress'],
    'QC1 Completed' :   ['QC1 Completed'],
    'QC2 In Progress' : ['QC2 In Progress'],
    'QC2 Completed' :   ['QC2 Completed'],
    'Drawings in Final Sign-Off': ['Final Signoff In Progress'],
    'Design Sign-Off Completed': ['Final Signoff Completed']
  };

  const selectedStages = stageMap[props.clickType];
  const simplifiedDrawingData = props.getCountData?.totalDrawingsData || [];

  const filteredIds = simplifiedDrawingData
    .filter(item => !selectedStages || selectedStages.includes(item.drawingQCStage))
    .map(item => item._id);

  const getAllDesignKickOffLeads = async () => {
    if (!filteredIds || filteredIds.length === 0) {
      setTableData([]);
      setTotalRows(0);
      return;
    }

    startLoading();
    try {
      const payload = {
        ids: filteredIds,
        page: page + 1,
        limit: rowsPerPage
      };

      const response = await HttpService.getAllClickedDrawingQCTableData(payload);

      setTableData(response.data.data);
      setTotalRows(response.data.total);

    } catch (error) {
      props.setSnackInfo(error);
    }
    stopLoading();
  };

  const csvHeaders = [
    { label: "S. No", key: "serialNo" },
    { label: "Project No", key: "projectCode" },
    { label: "Lead No.", key: "leadNo" },
    { label: "Client Name", key: "clientName" },
    { label: "Exp. Ctr. Name", key: "expCtrName" },
    { label: "Current Dwg Status", key: "drawingQCStage" },
    { label: "Assigned QC person", key: "assignedQCPersonName" },
    { label: "QC Manager", key: "qcManager" },
    { label: "Current Stage", key: "currentStage" },
    { label: "Department", key: "department" },
    { label: "Design executive", key: "designExec" },
    { label: "ADM", key: "adm" },
    { label: "ODM", key: "odm" },
    { label: "Sales Executive", key: "salesExec" },
    { label: "ASM", key: "asm" },
    { label: "Remarks", key: "remarks" },
  ];
  
  const handleDownload = () => {
    const csvFormattedData = tableData.map((item, index) => ({
      serialNo: index + 1,
      projectCode: item.uniqueLeadNumber || "NA",
      leadNo: item.lead_no || "NA",
      clientName: item?.customerId?.name || "NA",
      expCtrName: item?.experienceCenterId?.name || "NA",
      drawingQCStage: item?.drawingQCStage || "NA",
      assignedQCPersonName: item?.assignedQCPersonName || "NA",
      qcManager: item?.assignedQCPerson?.teamId?.name || "NA",
      currentStage: item?.currentStage || "NA",
      department: item?.departmentId?.name || "NA",
      designExec: item?.raisedQCDesignerName || "NA",
      adm: item?.checkListDesignerSignatureName || "NA",
      odm: item?.teamName || "NA",
      salesExec: item?.salesUser?.name || "NA",
      asm: item?.salesAssistantManager?.name || "NA",
      remarks: item?.remarks || "NA",
    }));
    setCsvData(csvFormattedData);
    setTimeout(() => csvRef.current.link.click());
  };

  const handleOpenRemarks = (logs) => {
    setSelectedRemarks(logs);
    setOpen(true);
  };

  const handleClose = () => { 
    setOpen(false); 
    setSelectedRemarks([]);
  };

  const handleChangeRowPerPage = (event) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };

  return (
    <>
      <Box className={classes.root}>

        <div style={{ textAlign: 'right', margin: '10px 0' }}>
          <Button
            variant="contained"
            style={{ backgroundColor: "#355025", color: "#FFF2EB" }}
            onClick={handleDownload}
          >
            <RiFileExcel2Fill style={{ fontSize: "20px", marginRight: '5px' }} />
            Download CSV
          </Button>

          <CSVLink
            data={csvData}
            headers={csvHeaders}
            filename={`drawing-table-${props.clickType || 'data'}.csv`}
            ref={csvRef}
            style={{ display: "none" }}
          />
        </div>

        <TableContainer component={Paper} style={{ flexGrow: 1 }}>
          <Table stickyHeader>
            <TableHead>
               <TableRow>
                <TableCell colSpan={16}>
                  <TablePagination
                    rowsPerPageOptions={[10, 50, 100, { label: 'All', value: totalRows}]}
                    component="div"
                    count={totalRows}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: { 'aria-label': 'rows per page' },
                      native: true,
                    }}
                    onRowsPerPageChange={handleChangeRowPerPage}
                    onPageChange={(e, newPage) => setPage(newPage)}
                    style={{ flexShrink: 0 }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.headerCell}>S. No</TableCell>
                {[
                  "Project No", "Lead No.", "Client Name", "Exp. Ctr. Name", "Quotation Value",
                  "Current Dwg Status", "Assigned QC person", "QC Manager",
                  "Current Stage", "Department", "Design executive",
                  "ADM", "ODM", "Sales Executive", "ASM", "Remarks"
                ].map((header, index) => (
                  <TableCell key={index} className={classes.headerCell}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {paginatedData.map((row, index) => (
                <TableRow
                  key={row._id || index}
                  className={index % 2 === 0 ? classes.tableRowEven : classes.tableRowOdd}
                >
                  <TableCell className={classes.cell}>{page * rowsPerPage + index + 1}</TableCell>

                  <TableCell className={classes.cell}>
                    {row?.uniqueLeadNumber ? (
                      <Link to={`/project-logs/${row?._id}`} style={{ color: "black", textDecoration: 'underline' }}>
                        {row.erpProjectNo}
                      </Link>
                    ) : 'NA'}
                  </TableCell>

                  <TableCell className={classes.cell}>
                    {row?.lead_no ? (
                      <Link to={`/project-logs/${row?._id}`} style={{ color: "black", textDecoration: 'underline' }}>
                        {row.lead_no}
                      </Link>
                    ) : 'NA'}
                  </TableCell>

                  <TableCell className={classes.cell}>{row?.customerId?.name || 'NA'}</TableCell>
                  <TableCell className={classes.cell}>{row?.experienceCenterId?.name || 'NA'}</TableCell>
                  <TableCell className={classes.cell}>{row.drawingQtValue || 'N/A'}</TableCell>
                  <TableCell className={classes.cell}>{row?.drawingQCStage || 'NA'}</TableCell>
                  <TableCell className={classes.cell}>{row?.assignedQCPersonName || 'NA'}</TableCell>
                  <TableCell className={classes.cell}>{row?.assignedQCManagerName || 'NA'}</TableCell>
                  <TableCell className={classes.cell}>{row?.currentStage || 'NA'}</TableCell>
                  <TableCell className={classes.cell}>{row?.departmentId?.name || 'NA'}</TableCell>
                  <TableCell className={classes.cell}>{row?.raisedQCDesignerName || 'NA'}</TableCell>
                  <TableCell className={classes.cell}>{row?.designAssistantManager?.name || 'NA'}</TableCell>
                  <TableCell className={classes.cell}>{row?.designManager?.name || 'NA'}</TableCell>
                  <TableCell className={classes.cell}>{row?.salesUser?.name || 'NA'}</TableCell>
                  <TableCell className={classes.cell}>{row?.salesAssistantManager?.name || 'NA'}</TableCell>

                  <TableCell className={classes.notesCell}>
                    <IoMdEye
                      style={{ fontSize: "30px", color: "#FDB913", cursor: "pointer" }}
                      onClick={() => handleOpenRemarks(row)}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={totalRows}
          rowsPerPage={10}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
        />
      </Box>

      {/* REMARKS POPUP */}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Remarks</DialogTitle>
        <DialogContent dividers>
          {selectedRemarks ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.headerCell}>User</TableCell>
                  <TableCell className={classes.headerCell}>Drawing QC Stages</TableCell>
                  <TableCell className={classes.headerCell}>Approved/Uploaded Time</TableCell>
                  <TableCell className={classes.headerCell}>Remarks</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>

                {selectedRemarks?.drawingQcAdmApprovedAt && (
                  <TableRow>
                    <TableCell>{selectedRemarks?.checkListDesignerSignatureName}</TableCell>
                    <TableCell>QC1 In progress</TableCell>
                    <TableCell>{moment(selectedRemarks.drawingQcAdmApprovedAt).format('DD-MM-YYYY hh:mm A')}</TableCell>
                    <TableCell>{selectedRemarks?.drawingQCFirstRemarks}</TableCell>
                  </TableRow>
                )}

                {selectedRemarks?.drawingQcOneApprovedAt && (
                  <TableRow>
                    <TableCell>{selectedRemarks?.qc1UserName}</TableCell>
                    <TableCell>QC1 Completed</TableCell>
                    <TableCell>{moment(selectedRemarks.drawingQcOneApprovedAt).format('DD-MM-YYYY hh:mm A')}</TableCell>
                    <TableCell>{selectedRemarks?.qc1Remarks}</TableCell>
                  </TableRow>
                )}

                {Array.isArray(selectedRemarks?.drawingQCTwoApproveLogs) &&
                  selectedRemarks.drawingQCTwoApproveLogs.map((log, index) => (
                    <TableRow key={index}>
                      <TableCell>{log.qcUserName}</TableCell>
                      <TableCell>{log.status}</TableCell>
                      <TableCell>{moment(log.changeStatusAt).format('DD-MM-YYYY hh:mm A')}</TableCell>
                      <TableCell>{log.qc2Remarks}</TableCell>
                    </TableRow>
                  ))}

              </TableBody>
            </Table>
          ) : <Typography>No remarks available.</Typography>}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="primary">Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default connect(null, { setLoading, setSnackInfo })(DrawingClickTable);